module.exports = __webpack_public_path__ + "static/media/royLogo.fdc2f670.png";